import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useContext } from 'react';
import "../index.css";
import { Link, useNavigate,useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';
function ListeningQuizThankYou() {
    const [activePage, setActivePage] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const SelectLanguageLocal = localStorage.getItem("selectedLanguage");
    const { Translate } = useContext(ProductContext);
    const ThankYouQuiz = location.state;
    // const categoryId = ThankYouQuiz?.categoryId;
    const dayId = ThankYouQuiz?.dayId;
    const is_review = ThankYouQuiz?.is_review;
    const examId = ThankYouQuiz?.examId;
    const examTypes = ThankYouQuiz?.examTypes;
    const selectedExamId = ThankYouQuiz?.selectedExamId;
    // const { quizTypeId, quizName } = location.state || {};

   const {
  categoryId,
  total_time_spent,
  quizTypeId,
  quizName,
} = location.state || {};

console.log(ThankYouQuiz, "ThankYouQuiz 1500")

    console.log(dayId, dayId,  "dayId quizName");
    console.log("RECEIVED. ListeningQuizThankYou 👉", quizTypeId, quizName);

    

    useEffect(() => {
        const loadLanguage = async () => {
            try {
                const storedLanguage = localStorage.getItem("selectedLanguage");
                console.log("storedLanguage", storedLanguage);
                if (storedLanguage) {
                    setSelectedLanguage(storedLanguage);
                }
            } catch (error) {
                console.error("Error loading language:", error);
            }
        };

        loadLanguage();
    }, []);
    return (
        <div className='Profile_Design_Main_Div_11'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon onClick={() => navigate(-1)} className='icon_1' />
                            <h2></h2>  {/* Display the selected day */}
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="thank-you-quiz-container">
                <div className="thank-you-content">
                    <h3>やったー！</h3>

                    <h2>{Translate?.message?.data?.youveCompletedTheQuiz || "You've Completed the Quiz!"}</h2>

                    <img
                        src={`${process.env.PUBLIC_URL}/assets/images/finishquiz.png`}
                        className="thank-you-quiz-img"
                    />

                    <div className="thank-you-quiz-button-group">


                        <button
                            className="thank-you-quiz-button"
                            onClick={() => {
                                navigate("/JLPTQuiz", {
                                    state: {
                                        categoryId,
                                        dayId,
                                        is_review,
                                        examId,
                                        examTypes,
                                        selectedExamId, // Ensure selectedExamId is passed
                                        quizTypeId, quizName
                                    },
                                });
                            }}
                        >{Translate?.message?.data?.startAnotherQuiz || "Start Another Quiz"}</button>

                        <Link to="/" className="thank-you-quiz-button-link">
                            <button className="thank-you-quiz-button">{Translate?.message?.data?.backToHome || "Back to Home"}</button>

                        </Link>
                    </div>
                </div>
            </div>

            {/* Footer Section */}
      <Footer />
    </div>
  );
}

export default ListeningQuizThankYou;
